import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

// Returns the stored Audit (same shape as getTailoredAudits items) so callers can update their
// display immediately instead of waiting for the invalidation-driven refetch (FIQ-682)
export const createTailoredAuditRejection = api(function createTailoredAuditRejection(audit) {
    return mutate(
        gql`
            mutation CreateTailoredAuditRejection($audit: JSONObject!) {
                createTailoredAuditRejection(audit: $audit) {
                    id
                    shortDescription
                    longDescription
                    referenceId
                    type
                    date
                    userId
                    userName
                    payload
                }
            }
        `,
        { audit },
        { returns: "createTailoredAuditRejection" }
    )
})
